export default __webpack_public_path__ + "static/media/IMG_8646.0d3be5fa.JPG";